import {workshopsGetters} from '../../../constants/vuexGetters'
import {workshopsVars} from '../../../constants/vuexVariables'

const getters = {
  [workshopsGetters.WORKSHOPS] (state) {
    return state[workshopsVars.WORKSHOPS] ? state[workshopsVars.WORKSHOPS] : null
  }
}

export default getters



// WEBPACK FOOTER //
// ./src/vuex/modules/workshops/getters.js